/**
 * Mirrors VerificationTaskType in the backend (Domain/Enums/CommonEnums.cs).
 *
 * The API registers a global JsonStringEnumConverter, so enums are serialized
 * by NAME, not by ordinal. These must stay string enums whose values match the
 * C# member names exactly.
 */
export enum VerificationTaskType {
  DocumentReview = 'DocumentReview',
  BackgroundCheck = 'BackgroundCheck',
  CertificationVerification = 'CertificationVerification',
  IdentityVerification = 'IdentityVerification',
  BankAccountVerification = 'BankAccountVerification',
  FacilityInspection = 'FacilityInspection',
  PasswordResetVerification = 'PasswordResetVerification',
  FacilityCorporateLinkVerification = 'FacilityCorporateLinkVerification'
}
